import React from 'react'

const DeleteTaskModal = ({closeDeleteModal}) => {
  return (
    <div>DeleteTaskModal</div>
  )
}

export default DeleteTaskModal